import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import configRequest from '@api/requests/configRequest';

import CustodianAgreementInterface from './interfaces/CustodianAgreementInterface.interface';

export interface AgreeCustodianAgreementData {
	application_id: number;
	custodian_agreement_id: number;
}

export interface AgreeCustodianAgreementResponse {
	custodian_agreement: CustodianAgreementInterface;
}

const agreeCustodianAgreement = configRequest<AgreeCustodianAgreementResponse, AgreeCustodianAgreementData>({
	requestPrefix: 'applications/agreeCustodianAgreement',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.APPLICATIONS.AGREE_CUSTODIAN_AGREEMENT(),
		method: HTTP_METHODS_ENUM.POST,
		data,
	}),
});

export default agreeCustodianAgreement;
